export type NetworkingFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type NetworkingFilterGroup = {
  id: string;
  label: string;
  options: NetworkingFilterOption[];
};

export const networkingFilterGroups: NetworkingFilterGroup[] = [
  {
    id: 'product-type',
    label: 'Loại sản phẩm',
    options: [
      { value: 'switch', label: 'Switch', keywords: ['switch'] },
      { value: 'router', label: 'Router', keywords: ['router'] },
      { value: 'mesh', label: 'Bộ Mesh Wifi', keywords: ['mesh'] },
      { value: 'network-card', label: 'Card Mạng', keywords: ['card mang', 'pci wifi'] },
      { value: 'usb-bluetooth', label: 'USB Bluetooth', keywords: ['usb bluetooth'] },
      { value: 'usb-wifi', label: 'USB WiFi', keywords: ['usb wifi', 'usb thu wifi'] },
      { value: 'wifi-device', label: 'Thiết bị Wifi', keywords: ['thiet bi wifi'] },
      { value: 'cable', label: 'Cáp mạng', keywords: ['cap mang', 'day mang'] },
      { value: 'connector', label: 'Đầu mạng', keywords: ['dau mang', 'hat mang'] },
      { value: 'crimping-tool', label: 'Kềm bấm mạng', keywords: ['kem bam mang'] },
      { value: 'other', label: 'Thiết bị khác', keywords: ['thiet bi khac'] },
    ],
  },
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'aptek', label: 'Aptek', keywords: ['aptek'] },
      { value: 'asus', label: 'Asus', keywords: ['asus'] },
      { value: 'aruba', label: 'Aruba', keywords: ['aruba'] },
      { value: 'cisco', label: 'Cisco', keywords: ['cisco'] },
      { value: 'd-link', label: 'D-Link', keywords: ['d-link', 'dlink'] },
      { value: 'draytek', label: 'Draytek', keywords: ['draytek'] },
      { value: 'ruijie', label: 'Ruijie Reyee', keywords: ['ruijie', 'reyee'] },
      { value: 'tenda', label: 'Tenda', keywords: ['tenda'] },
      { value: 'tp-link', label: 'TP-Link', keywords: ['tp-link', 'tplink'] },
      { value: 'toto-link', label: 'Toto-Link', keywords: ['toto-link', 'totolink'] },
      { value: 'unifi', label: 'UniFi', keywords: ['unifi'] },
      { value: 'mikrotik', label: 'MikroTik', keywords: ['mikrotik'] },
    ],
  },
  {
    id: 'need',
    label: 'Nhu cầu',
    options: [
      { value: 'home', label: 'Gia Đình', keywords: ['gia dinh', 'home'] },
      {
        value: 'business',
        label: 'Doanh Nghiệp',
        keywords: ['doanh nghiep', 'business', 'enterprise'],
      },
      { value: 'gaming', label: 'Gaming', keywords: ['gaming'] },
    ],
  },
  {
    id: 'standard',
    label: 'Chuẩn kết nối',
    options: [
      { value: 'n', label: 'Chuẩn N', keywords: ['chuan n', '802.11n'] },
      { value: 'ac', label: 'Chuẩn AC', keywords: ['chuan ac', '802.11ac'] },
      { value: 'ax', label: 'Chuẩn AX', keywords: ['chuan ax', '802.11ax'] },
      { value: 'wifi5', label: 'Wifi 5', keywords: ['wifi 5', 'wifi5'] },
      { value: 'wifi6', label: 'Wifi 6', keywords: ['wifi 6', 'wifi6'] },
    ],
  },
];
